
const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const sizeName='size';
function initSizeGate(form){
  if(form.dataset.btSizeRequired===undefined)return;
  const field=$$('.variant-option[data-option-name]',document).find(el=>(el.dataset.optionName||'').trim().toLowerCase()===sizeName && el.querySelectorAll('input,select,button').length>1);
  if(!field){form.dataset.btSizeSatisfied='true';return;}
  // A server-side variant deep-link is an intentional selection signal.
  if(new URLSearchParams(location.search).has('variant')) form.dataset.btSizeSatisfied='true';
  const satisfy=()=>{form.dataset.btSizeSatisfied='true';delete form.dataset.btSizeMissing;field.classList.remove('bt-size-attention');};
  field.addEventListener('change',satisfy,true); field.addEventListener('click',e=>{if(e.target.closest('label,input,button,select,option')) satisfy();},true);
  form.addEventListener('submit',e=>{
    if(form.dataset.btSizeSatisfied==='true')return;
    e.preventDefault();e.stopImmediatePropagation();form.dataset.btSizeMissing='true';field.classList.add('bt-size-attention');
    field.scrollIntoView({behavior:'smooth',block:'center'}); const focus=field.querySelector('input:not([disabled]),select,button:not([disabled])'); setTimeout(()=>focus?.focus({preventScroll:true}),280);
  },true);
}
function initSticky(bar){
  const section=bar.closest('.shopify-section')||document;
  const form=section.querySelector('product-form-component'); if(!form)return;
  const original=form.querySelector('[ref="addToCartButton"],button[name="add"],button[type="submit"]'); if(!original)return;
  const button=bar.querySelector('[data-bt-sticky-button]');
  const price=bar.querySelector('[data-bt-sticky-price]');
  const mainButtons=form.querySelector('.product-form-buttons')||original;
  const update=()=>{button.disabled=!!original.disabled; if(price){const p=section.querySelector('product-price, .price, [data-product-price]'); if(p) price.textContent=p.textContent.trim().replace(/\s+/g,' ');}};
  button.addEventListener('click',()=>original.click());
  const io=new IntersectionObserver(entries=>{const visible=entries[0]?.isIntersecting;bar.classList.toggle('is-visible',!visible && window.scrollY>120);},{threshold:.05}); io.observe(mainButtons);
  new MutationObserver(update).observe(form,{subtree:true,childList:true,attributes:true}); update();
}
function boot(){ $$('product-form-component[data-bt-size-required]').forEach(initSizeGate); $$('[data-bt-sticky-atc]').forEach(initSticky); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
